import {
  FlexibilityCommandBattery,
  FlexibilityCommandPv,
} from '../../shared/enums';

export enum FlexibilityCommandType {
  DeltaGreenBusinessFlexibility = 'business-flexibility',
  PreFlexibility = 'pre-flexibility',
  BezDodavatele = 'bez-dodavatele',
  Electree = 'electree',
  Energomachine = 'energomachine',
}

/**
 * The normalised command the control logic acts on. Partner payloads are stored
 * in their own shape and reduced to this by the resolvers in
 * `flexibility-command-resolver.ts`.
 */
export type FlexibilityActiveCommand = {
  battery: FlexibilityCommandBattery;
  pv: FlexibilityCommandPv;
  target_soc_percentage?: number;
};
